import backIcon from "assets/images/back-icon.svg";
import { useHistory } from "react-router-dom";
import * as Styles from "./Rezept.styles";

import RezeptSlider from "./RezeptSlider";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { KALORIEN } from "routes/routes";
import { useSelector } from "react-redux";

function Rezept() {
  const history = useHistory();
  const handleBtnClick = () => {
    history.push(KALORIEN);
  };
  const { allNutritionsData } = useSelector((state) => state.coach);
  console.log("🚀 ~ Rezept ~ allNutritionsData:", allNutritionsData);

  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Auswertung"}
          subHeadline={"Auf dein Ziel abgestimmte Rezepte"}
          handleNextPage={handleBtnClick}
          noBackButton={true}
        />
        <Styles.ContentSection>
          <Styles.Title>Eine kleine Auswahl deiner Rezepte:</Styles.Title>
          <Styles.Description>
            Keine Einschränkungen im Alltag, völlige Flexibilität.
          </Styles.Description>
          <Styles.RezeptTitle>Über 1700 Rezepte:</Styles.RezeptTitle>
          <RezeptSlider data={allNutritionsData.recipeData} />
        </Styles.ContentSection>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show "
      >
        Weiter
      </button>
    </Styles.Container>
  );
}

export default Rezept;
